module.exports = __webpack_public_path__ + "assets/img/watchingAssistant.ac11d410.png";